var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcOpacity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/24px/Layers dupli 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Query",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Objects-properties",
    transform: "translate(-617.000000, -167.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(95.000000, 109.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Drillhole-properties-Copy",
    transform: "translate(310.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/24px/Layers-dupli-3",
    transform: "translate(210.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,15.625 L17.5,4.375 C17.5,3.34375 16.65625,2.5 15.625,2.5 L4.375,2.5 C3.34375,2.5 2.5,3.34375 2.5,4.375 L2.5,15.625 C2.5,16.65625 3.34375,17.5 4.375,17.5 L15.625,17.5 C16.65625,17.5 17.5,16.65625 17.5,15.625 L17.5,15.625 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16666667,7.5 L10.8333333,7.5 L10.8333333,9.16666667 L9.16666667,9.16666667 L9.16666667,7.5 Z M7.5,9.16666667 L9.16666667,9.16666667 L9.16666667,10.8333333 L7.5,10.8333333 L7.5,9.16666667 Z M10.8333333,9.16666667 L12.5,9.16666667 L12.5,10.8333333 L10.8333333,10.8333333 L10.8333333,9.16666667 Z M12.5,7.5 L14.1666667,7.5 L14.1666667,9.16666667 L12.5,9.16666667 L12.5,7.5 Z M5.83333333,7.5 L7.5,7.5 L7.5,9.16666667 L5.83333333,9.16666667 L5.83333333,7.5 Z M15.8333333,2.5 L4.16666667,2.5 C3.25,2.5 2.5,3.25 2.5,4.16666667 L2.5,15.8333333 C2.5,16.75 3.25,17.5 4.16666667,17.5 L15.8333333,17.5 C16.75,17.5 17.5,16.75 17.5,15.8333333 L17.5,4.16666667 C17.5,3.25 16.75,2.5 15.8333333,2.5 L15.8333333,2.5 Z M7.5,15 L5.83333333,15 L5.83333333,13.3333333 L7.5,13.3333333 L7.5,15 L7.5,15 Z M10.8333333,15 L9.16666667,15 L9.16666667,13.3333333 L10.8333333,13.3333333 L10.8333333,15 L10.8333333,15 Z M14.1666667,13.3333333 L14.1666667,15 L12.5,15 L12.5,13.3333333 L14.1666667,13.3333333 Z M15.8333333,10.8333333 L15.8333333,12.5 L14.1666667,12.5 L14.1666667,10.8333333 L15.8333333,10.8333333 Z M5.83333333,12.5 L4.16666667,12.5 L4.16666667,10.8333333 L5.83333333,10.8333333 L5.83333333,9.16666667 L4.16666667,9.16666667 L4.16666667,4.16666667 L15.8333333,4.16666667 L15.8333333,9.16666667 L14.1666667,9.16666667 L14.1666667,10.8333333 L12.5,10.8333333 L12.5,12.5 L10.8333333,12.5 L10.8333333,10.8333333 L9.16666667,10.8333333 L9.16666667,12.5 L7.5,12.5 L7.5,10.8333333 L5.83333333,10.8333333 L5.83333333,12.5 Z",
    id: "-\\u21B3Color",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,15.625 L17.5,4.375 C17.5,3.34375 16.65625,2.5 15.625,2.5 L4.375,2.5 C3.34375,2.5 2.5,3.34375 2.5,4.375 L2.5,15.625 C2.5,16.65625 3.34375,17.5 4.375,17.5 L15.625,17.5 C16.65625,17.5 17.5,16.65625 17.5,15.625 L17.5,15.625 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOpacity);
export default __webpack_public_path__ + "static/media/ic_opacity.215e60d1275d5f2446e604d58410a830.svg";
export { ForwardRef as ReactComponent };